$(document).ready(function(){
  $('.nav-mobile-menu').click(function(){
    $('.rhinox-mobile-menu').show();
  });
  $('.rhinox-menu-open').on("click", function(e){
    var level1 = $(this).attr("id");
    $(this).find(".mobile-menu-name").css('color', '#ecb800');
    if(level1 == "menu-level-one"){ 
      $(this).siblings('ul').hide();
      $(this).removeAttr('id');
      $(this).find(".fa-angle-up").attr('class', 'fa fa-angle-down down-arrow');
      $(this).find(".mobile-menu-name").css('color', 'black');
    }else{
      $(this).siblings('ul').show();
      $(this).attr('id', 'menu-level-one');
      $(this).find(".fa-angle-down").attr('class', 'fa fa-angle-up down-arrow');
    }
    e.stopPropagation();
    e.preventDefault();
  });
  $('.rhinox-menu-level2').on("click", function(e){
    var level2 = $(this).attr("id");
    $(this).find(".mobile-menu-name").css('color', '#ecb800');
    if(level2 == "menu-level-two"){
      $(this).next('ul').hide();
      $(this).removeAttr('id');
      $(this).find(".fa-angle-up").attr('class', 'fa fa-angle-down down-arrow');
      $(this).find(".mobile-menu-name").css('color', 'black');
    }else{
      $(this).next('ul').show();
      $(this).attr('id', 'menu-level-two');
      $(this).find(".fa-angle-down").attr('class', 'fa fa-angle-up down-arrow');
    }
    e.stopPropagation();
    e.preventDefault();
  });
  $('.rhinox-menu-level3').on("click", function(e){
    var level3 = $(this).attr("id");
    $(this).find(".mobile-menu-name").css('color', '#ecb800');
    if(level3 == "menu-level-three"){  
      $(this).next('ul').hide();
      $(this).removeAttr('id');
      $(this).find(".fa-angle-up").attr('class', 'fa fa-angle-down down-arrow');
      $(this).find(".mobile-menu-name").css('color', 'black');
    }else{
      $(this).next('ul').show();
      $(this).attr('id', 'menu-level-three');
      $(this).find(".fa-angle-down").attr('class', 'fa fa-angle-up down-arrow');
    }
    e.stopPropagation();
    e.preventDefault();
  }); 
});

$(document).mouseup(function(e) {
  var container = $(".rhinox-mobile-menu");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.hide();
  }
});